var _path, _circle, _circle2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisaDebitIconColor2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m23.188 13.768-5.236 12.494h-3.418l-2.575-9.97c-.158-.615-.294-.838-.769-1.1-.778-.42-2.06-.815-3.19-1.061l.08-.363h5.498c.7 0 1.331.468 1.49 1.274l1.361 7.232 3.363-8.506h3.396Zm13.386 8.413c.015-3.296-4.56-3.475-4.527-4.95.009-.45.435-.926 1.37-1.046.463-.062 1.74-.107 3.187.558l.567-2.649a8.686 8.686 0 0 0-3.023-.553c-3.195 0-5.443 1.7-5.462 4.13-.021 1.798 1.604 2.801 2.83 3.4 1.26.613 1.68 1.004 1.676 1.553-.009.839-1.005 1.206-1.934 1.222-1.625.025-2.568-.44-3.321-.79l-.585 2.74c.754.346 2.15.646 3.595.664 3.395 0 5.616-1.681 5.627-4.279Zm8.436 4.081H48l-2.609-12.494h-2.76c-.62 0-1.143.362-1.376.916l-4.847 11.579H39.8l.674-1.866h4.147l.389 1.866Zm-3.607-4.426 1.703-4.692.979 4.692h-2.682Zm-13.596-8.068-2.675 12.494H21.9l2.675-12.494h3.232Z",
    fill: "#1A2ADF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 76.485,
    cy: 20,
    r: 11,
    fill: "#F79E1C"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 20,
    r: 11,
    fill: "#EA001B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.742 28.69a10.981 10.981 0 0 0 4.257-8.692 10.98 10.98 0 0 0-4.257-8.691 10.981 10.981 0 0 0-4.258 8.691 10.98 10.98 0 0 0 4.258 8.692Z",
    fill: "#FF5F01"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaDebitIconColor2);
export default __webpack_public_path__ + "static/media/visa-debit-icon-color-2.d2bc3f9ee0d1e3b3877fb0c274f428a6.svg";
export { ForwardRef as ReactComponent };